import * as React from 'react';
import {
  Avatar, Paper, Typography, Box,
} from '@material-ui/core';

import type { Theme } from '@material-ui/core/styles';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import clsx from 'clsx';
import globalUseStyles from '../../globalClasses';

const useStyles = makeStyles((theme: Theme) => createStyles({
  margins: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.25),
    marginRight: theme.spacing(0.25),
  },
  paperOverrides: {
    minWidth: '0',
    backgroundColor: '#F2F2F2',
    marginTop: theme.spacing(1),
  },
}));

const JewelerSidebar: React.FC<{ count:string, icon:React.ReactElement, iconColor: 'red' | 'blue' | 'green' }> = ({ count, icon, iconColor }) => {
  const classes = useStyles();
  const globalStyles = globalUseStyles();

  const iconColorClass = () => {
    if (iconColor === 'green') {
      return globalStyles.greenIcon;
    }
    if (iconColor === 'blue') {
      return globalStyles.blueIcon;
    }
    return globalStyles.redIcon;
  };

  return (
    <Box p={1}>
      <Avatar className={clsx(globalStyles.smallAvatar, iconColorClass(), classes.margins)}>
        {icon}
      </Avatar>
      <Paper
        elevation={0}
        className={clsx(classes.paperOverrides)}
      >
        <Typography variant="body1" align="center" className={classes.margins}>
          {count}
        </Typography>
      </Paper>
    </Box>
  );
};

export default JewelerSidebar;
